import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { PersonalDataFormBean, PersonalDataFormController, PersonalIdentifierType } from '../../common/common.types';
import { patientTranslationKeys } from '../../translations';

import { useGoToPatient, useGuardianCreateCommand, usePatientCreateCommand } from './CreatePatientAction.hooks';

type CreatePatientActionProps = Pick<PersonalDataFormController, 'handleSubmit' | 'markPristine'>;

const CreatePatientAction = (props: CreatePatientActionProps): JSX.Element => {
   const goToPatient = useGoToPatient();
   const { executeAsync: createPatient } = usePatientCreateCommand();
   const { executeAsync: createGuardian } = useGuardianCreateCommand();

   const handleSubmit = props.handleSubmit(async (data: PersonalDataFormBean) => {
      const patientId = await createPatient(data);
      if (data.personalIdentifierType.id === PersonalIdentifierType.GUARDIAN_PESEL && data.identifyingGuardian) {
         await createGuardian({
            bean: data.identifyingGuardian,
            patientId: patientId,
         });
      }

      props.markPristine();
      goToPatient(patientId);
   });

   return (
      <ActionBar.PrimaryButton
         testId={'addPatient'}
         label={patientTranslationKeys.addPatientButton}
         variant={ButtonVariant.PRIMARY}
         onClick={handleSubmit}
         blockingOperation
      />
   );
};

export { CreatePatientAction };
